export enum OptimizationType {
  Reliability = 1,
  Availability = 2,
  Functionality = 3,
  Survivability = 4,
  EngineeringJudgement = 5,
  Commercial = 6,
  ProbabilityOfFailureOnDemand = 7
}
